import React from 'react';
import Box, { BoxProps } from 'ui-box';
import { defaultFills, minorScale } from '../../npaper';
import { IUser } from '../../stores';

export const UserThumbnail: React.FC<
  BoxProps<'div'> & { user: IUser; size?: number; showName?: boolean }
> = ({ user, size = 32, showName = false, ...props }) => {
  return (
    <Box display="inline-flex" alignItems="center" {...props}>
      <Box
        width={size}
        height={size}
        borderRadius={size / 2}
        backgroundColor={defaultFills.normal[100]}
        display="flex"
        alignItems="center"
        justifyContent="center"
        border={`2px solid ${defaultFills.normal[100]}`}
      >
        <span className="p small" style={{ color: defaultFills.normal[600] }}>
          {user.initials.toUpperCase()}
        </span>
      </Box>
      {showName && (
        <Box is="span" className="p" marginLeft={minorScale(1)}>
          {user.name}
        </Box>
      )}
    </Box>
  );
};
